import React from 'react';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ activeMenu, setActiveMenu, user, onLogout, isOpen, toggleSidebar, contextoLoja, setAnaliseSubmenu }) => {
  const navigate = useNavigate();

  // Proteção contra usuário nulo/undefined
  if (!user) {
    return null;
  }

  let menuItems = [];
  const isSuperAdmin = user.tipo === 'super_admin' || user.cargo === 'Admin';
  const isFinanceiro = String(user.cargo || user.tipo || '').toLowerCase() === 'financeiro';
  // Se estiver em contexto de loja (super admin acessando loja), comportar-se como gerente/admin da loja
  const isModoOperacional = !isSuperAdmin || contextoLoja;

  if (isModoOperacional && !isFinanceiro) {
    menuItems.push({ id: 'estoque', label: 'Estoque', icon: 'package' });
    menuItems.push({ id: 'fichas', label: 'Fichas', icon: 'file-text' });
  }

  if (!isFinanceiro && (user.cargo === 'Analista' || (isSuperAdmin && contextoLoja))) {
    menuItems.push({ id: 'analise', label: 'Análise', icon: 'bar-chart-2' });
  }

  if (!isFinanceiro && (user.cargo === 'Analista' || user.cargo === 'Gerente' || (isSuperAdmin && contextoLoja))) {
    menuItems.push({ id: 'negociacoes', label: 'Negociações', icon: 'briefcase' });
  }

  if (!isFinanceiro) {
    menuItems.push({ id: 'documentacao', label: 'Documentação', icon: 'file-text' });
  }

  if (isModoOperacional || isSuperAdmin) {
    menuItems.push({
      id: 'financeiro_contas',
      label: 'Financeiro',
      icon: 'dollar',
      route: isSuperAdmin && !contextoLoja ? '/admin/financeiro' : undefined
    });
  }

  if (!isFinanceiro && (user.cargo === 'Gerente' || user.cargo === 'Analista' || user.cargo === 'Vendedor' || (isSuperAdmin && contextoLoja))) {
    menuItems.push({ id: 'configuracoes', label: 'Configurações', icon: 'settings' });
  }

  // Menu Lojas para Super Admin
  if (!isSuperAdmin && Array.isArray(user.menus_efetivos)) {
    const rotulos = { estoque: 'Estoque', fichas: 'Fichas', analise: 'Análise', negociacoes: 'Negociações', documentacao: 'Documentação', financeiro_contas: 'Financeiro', configuracoes: 'Configurações' };
    menuItems = Object.entries(rotulos).filter(([id]) => user.menus_efetivos.includes(id)).map(([id, label]) => ({ id, label }));
  }
  if (user.gerenciar_acessos && !menuItems.some(item => item.id === 'configuracoes')) {
    menuItems.push({ id: 'configuracoes', label: 'Configurações', icon: 'settings' });
  }

  // Menu Lojas para Super Admin
  if (isSuperAdmin) {
     menuItems.push({ id: 'lojas', label: 'Gerenciar Lojas', icon: 'grid', route: '/admin/lojas' });
     if (!contextoLoja) {
       menuItems.push({ id: 'bps_acessos', label: 'Acessos BPS', icon: 'users' });
     }
  }

  return (
    <>
      {/* Overlay para mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
      
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img
              src="/logo.png"
              alt="VETIM"
              width="150"
              height="50"
              onError={(e) => {
                const img = e.currentTarget;
                // Evitar loop infinito de reload
                if (!img.dataset.retry) {
                  img.dataset.retry = '1';
                  img.src = `/logo.png?v=${Date.now()}`;
                }
              }}
            />
          </div>
          <button className="close-sidebar mobile-only" onClick={toggleSidebar}>×</button>
        </div>
        
        <div className="user-profile">
          <div 
            className="user-avatar logout-trigger" 
            onClick={onLogout}
            title="Sair"
          >
            <span className="avatar-initial">
              {(user.name || user.nome) ? (user.name || user.nome).charAt(0).toUpperCase() : 'U'}
            </span>
            <span className="logout-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </span>
          </div>
          <div className="user-details">
            <p className="user-name">{user.name || user.nome || 'Usuário'}</p>
            <p className="user-email">{user.email}</p>
            <p className="user-role">{user.cargo || user.tipo}</p>
            {user.loja && <p className="user-store">{user.loja.nome}</p>}
          </div>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
              onClick={() => {
                if (item.route) {
                  navigate(item.route);
                } else if (setActiveMenu) {
                  if (item.id === 'analise') setAnaliseSubmenu?.(null);
                  setActiveMenu(item.id);
                }
                if (window.innerWidth <= 768) toggleSidebar();
              }}
            >
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
